<template>
  <v-footer app class="app-footer text-caption text-medium-emphasis justify-center flex-wrap">
    <span>{{ company.shortName }}</span>
    <template v-for="link in links" :key="link.to">
      <span class="mx-2">·</span>
      <router-link :to="link.to" class="text-medium-emphasis">{{ link.title }}</router-link>
    </template>
  </v-footer>
</template>

<script>
import { COMPANY, LEGAL_LINKS } from '@/config/legal'

export default {
  name: 'AppFooter',
  data() {
    return {
      company: COMPANY,
      links: [
        { to: '/', title: 'Главная' },
        { to: LEGAL_LINKS.requisites, title: 'Реквизиты и контакты' },
        { to: LEGAL_LINKS.terms, title: 'Условия использования' },
        { to: LEGAL_LINKS.privacy, title: 'Политика обработки персональных данных' }
      ]
    }
  }
}
</script>

<style scoped>
.app-footer {
  flex: 0 0 auto;
  padding: 6px 16px;
  row-gap: 2px;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
